var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.seasons),function(season){return _c('article',{key:season._id},[_c('header',[_c('SeasonInfo',{attrs:{"season":season}})],1),_c('div',[_vm._t("default",null,{"season":season})],2)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }